import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-14 h-14 overflow-hidden rounded-full flex justify-center items-center minimized-icon" }
const _hoisted_2 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  height: "1.6em",
  viewBox: "0 0 512 512",
  style: {"fill":"var(--minimized-icon-color)"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M101.9 387.7l10.8-28.9L90.9 336.9C63 308.9 48 275.1 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-26.8 0-52.3-3.9-75.7-11l-13.9-4.2-13.9 4.2L94.9 406.2l7-18.5zM16 480l57.8-17.3 92.6-27.8c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L37.2 423.5 16 480zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "h-5 w-5 animate-spin",
  xmlns: "http://www.w3.org/2000/svg",
  height: "1.6em",
  viewBox: "0 0 24 24",
  style: {"fill":"var(--minimized-icon-color)"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", { d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]


export default /*#__PURE__*/_defineComponent({
  __name: 'MinimizedButton',
  props: {
  loading: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    (!__props.loading)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
  ]))
}
}

})